import axios from '@/plugins/axios';
export let Api_login = {
  // 用户登录
  login: (data) => {
    return axios({
      url: `/login/user-login-for-web`,
      method: 'post',
      data: data,
    });
  },

  // 用户登录
  logout: () => {
    return axios({
      url: `/login/user-logout-for-web`,
      method: 'get',
    });
  },

  // 根据用户ID获取登录用户信息
  userInfo: (userid) => {
    return axios({
      url: `/login/user-info/${userid}`,
      method: 'get',
    });
  },
  // 验证手机号是否合法
  checkNumber: (number) => {
    return axios({
      url: `/login/check-number/${number}`,
      method: 'get',
    });
  },
  // 向手机号发送验证码
  sendMsg: (data) => {
    return axios({
      url: `/login/sent-msg/${data}`,
      method: 'post',
    });
  },
  //向邮箱发送验证码
  sendEmail: (data) => {
    return axios({
      url: `/login/sent-email-code/${data}`,
      method: 'post',
    });
  },
  // 验证码核对
  checkCode: (data) => {
    return axios({
      url: `/login/check-code`,
      method: 'post',
      data: data,
    });
  },
  // 验证邮箱验证码
  checkEmailCode: (data) => {
    return axios({
      url: `/login/check-email-code`,
      method: 'post',
      data: data,
    });
  },

  // 更新用户手机号
  updatePhone: (data) => {
    return axios({
      url: `/user-system/user-phone`,
      method: 'post',
      data: data,
    });
  },
  // 二次验证手机号
  checkTime: (userId) => {
    return axios({
      url: `/login/set-user-login-time-and-second-check-time/${userId}`,
      method: 'get',
    });
  },
  // 整合用户管理列表
  appUserList: (data) => {
    return axios({
      url: `/api/middle-user/page-list`,
      method: 'post',
      data: data,
    });
  },
  loginForCompany: (content) => {
    console.log('content=', content);
    return axios({
      url: `/login/user-re-login-for-company/${content.projectId}/pk`,
      method: 'post',
    });
  },
  // 根据公司id获取此公司下面分公司列表
  getCompanyList: (companyid) => {
    return axios({
      url: `/company/list-company-by-id/${companyid}`,
      method: 'get',
    });
  },
  // 根据公司id获取此公司下面的项目
  getProjectList: (companyid) => {
    return axios({
      url: `/company/list-porject-by-id/${companyid}`,
      method: 'get',
    });
  },
  // 递归加载公司树
  getCompanyTree: (companyid) => {
    return axios({
      url: `/company/tree-company/${companyid}`,
      method: 'get',
    });
  },
  getBarMenus: (userid) => {
    return axios({
      url: `/login/bar-menus/${userid}`,
      method: 'get',
    });
  },
  GetVerificationCode: (guid) => {
    return axios({
      url: `/login/verification-code/${guid}`,
      method: 'get',
      responseType: 'blob',
    });
  },
  // 埋点注入
  buryPoint: (data) => {
    return axios({
      url: `/api/event-tracking-platform-module/inject`,
      method: 'post',
      data: data,
    });
  },
};
export let Api_SuperAdmin = {
  // 公司列表
  list: (content) => {
    return axios({
      url: `/user-system/company-list`,
      method: 'post',
      data: content,
    });
  },
  // 所有公司列表
  allList: () => {
    return axios({
      url: `/user-system/company-name-id`,
      method: 'get',
    });
  },

  // 添加公司
  add: (content) => {
    return axios({
      url: `/user-system/company-add`,
      method: 'post',
      data: content,
    });
  },
  // 编辑公司
  edit: (content) => {
    return axios({
      url: `/user-system/company-edit`,
      method: 'post',
      data: content,
    });
  },
  // 删除公司
  del: (id) => {
    return axios({
      url: `/user-system/company-delete/` + id,
      method: 'post',
    });
  },
  // 公司详情
  detail: (id) => {
    return axios({
      url: `/user-system/company-model/` + id,
      method: 'get',
    });
  },

  // 项目列表
  projectList: (content) => {
    return axios({
      url: `/user-system/project-list`,
      method: 'post',
      data: content,
    });
  },

  // 添加项目
  addProject: (content) => {
    return axios({
      url: `/user-system/project-add`,
      method: 'post',
      data: content,
    });
  },

  delProject: (id) => {
    return axios({
      url: `/user-system/project-delete/` + id,
      method: 'post',
    });
  },

  editProject: (content) => {
    return axios({
      url: `/user-system/project-edit`,
      method: 'post',
      data: content,
    });
  },
  // 项目详情
  projectDetail: (id) => {
    return axios({
      url: `/user-system/project-model/${id}`,
      method: 'get',
    });
  },

  // 菜单列表
  menuList: () => {
    return axios({
      url: `/user-system/all-menu`,
      method: 'get',
    });
  },
  // 菜单列表和搜索的
  treeMenus: (data) => {
    return axios({
      url: `/user-system/tree-menus`,
      method: 'post',
      data: data,
    });
  },
  // 菜单分页列表
  menuPageList: (data) => {
    return axios({
      url: `/user-system/menu-model-page-list`,
      method: 'post',
      data: data,
    });
  },
  // 添加菜单
  addMenu: (content) => {
    return axios({
      url: `/user-system/menu-add`,
      method: 'post',
      data: content,
    });
  },
  // 菜单详情
  menuDetail: (id) => {
    return axios({
      url: `/user-system/menu-model/` + id,
      method: 'get',
    });
  },
  editMenu: (content) => {
    return axios({
      url: `/user-system/menu-edit`,
      method: 'post',
      data: content,
    });
  },

  delMenu: (id) => {
    return axios({
      url: `/user-system/menu-delete/` + id,
      method: 'post',
    });
  },

  // 规模列表
  unitList: () => {
    return axios({
      url: `/user-system/project-unit-list`,
      method: 'get',
    });
  },

  // 菜单详情
  modulesDetail: (companyid) => {
    return axios({
      url: `/user-system/company-get-menu/` + companyid,
      method: 'post',
    });
  },
  // 超级管理员》菜单详情(根据公司id获取公司子菜单，不包含根菜单)
  modulesSubDetail: (companyid) => {
    return axios({
      url: `/user-system/company-get-sub-menu/` + companyid,
      method: 'post',
    });
  },
  //根据公司id获取公司级App子菜单（不包含根菜单）
  modulesSubAPPDetail: (companyid) => {
    return axios({
      url: `/user-system/company-get-sub-app-menu/` + companyid,
      method: 'post',
    });
  },
  // 超级管理员》公司管理》配置授权
  setModules: (content) => {
    return axios({
      url: `/user-system/company-menu-add`,
      method: 'post',
      data: content,
    });
  },
  // 超级管理员》公司管理》APP配置授权
  setAPPModules: (content) => {
    return axios({
      url: `/user-system/company-app-menu-add`,
      method: 'post',
      data: content,
    });
  },
  // 超级管理员》项目管理》所有菜单列表
  modulesProjectDetail: (companyid) => {
    return axios({
      url: `/user-system/project-menus/${companyid}`,
      method: 'get',
    });
  },
  // 超级管理员》项目管理》获取选中菜单列表
  getProjectSelect: (projectid) => {
    return axios({
      url: `/user-system/project-menu/${projectid}`,
      method: 'get',
    });
  },
  // 超级管理员》项目管理》获取选中菜单列表（不包含根节点）
  getProjectSubSelect: (projectid) => {
    return axios({
      url: `/user-system/project-sub-menu/${projectid}`,
      method: 'get',
    });
  },
  // 超级管理员》项目管理》保存项目权限菜单
  setProjectModules: (content) => {
    return axios({
      url: `/user-system/project-menu`,
      method: 'post',
      data: content,
    });
  },
  // 超级管理员》项目管理》获取菜单信息
  getModules: () => {
    return axios({
      url: `/user-system/company-get-all-menu`,
      method: 'post',
    });
  },
  // 超级管理员》菜单管理》获取分类列表
  getTopMenus: () => {
    return axios({
      url: `/user-system/top-menus`,
      method: 'get',
    });
  },
  // 超级管理员》首页模块管理》添加或更新数据
  editHome: (content) => {
    return axios({
      url: `/modul/or-edit`,
      method: 'post',
      data: content,
    });
  },
  // 超级管理员》首页模块管理》列表
  getHomeList: content => {
    return axios({
      url: `/modul/page-list`,
      method: 'post',
      data: content,
    });
  },
  // 超级管理员》首页模块管理》删除
  delHome: (id) => {
    return axios({
      url: `/modul/del/${id}`,
      method: 'post',
    });
  },
  // 超级管理员》公司级菜单管理》 获取公司首页父即菜单列表(无分页)
  getData: content => {
    return axios({
      url: `/system-config/list`,
      method: 'post',
      data: content,
    });
  },
  // 超级管理员》公司级菜单管理》 获取公司首页父级菜单详情
  detailMenuCom: (id) => {
    return axios({
      url: `/system-config/detail/${id}`,
      method: 'get',
    });
  },
  // 超级管理员》公司级菜单管理》 添加或编辑公司首页父级菜单
  editMenuCom: content => {
    return axios({
      url: `/system-config/index-menu-insert-or-update`,
      method: 'post',
      data: content,
    });
  },
  //  超级管理员》公司级菜单管理》删除公司首页父级
  delMenuCom: (content) => {
    return axios({
      url: `/system-config/${content.indexCompanyMenuId}`,
      method: 'post',
      data: content,
    });
  },
  //  超级管理员》省份模板管理 》保存模板
  saveProvinceTemplate: (content) => {
    return axios({
      url: `/system-province-template/template-save`,
      method: 'post',
      data: content,
    });
  },
  //  超级管理员》省份模板管理 》模板列表
  getTemplateList: (content) => {
    return axios({
      url: `/system-province-template/authority-template-list`,
      method: 'post',
      data: content,
    });
  },
  // 超级管理员》省份模板管理》获取一条模板信息
  detailTemplate: (id) => {
    return axios({
      url: `/system-province-template/template-model/${id}`,
      method: 'get',
    });
  },
  //  超级管理员》省份模板管理 》模板删除
  delTemplate: (id) => {
    return axios({
      url: `/system-province-template/template-delete/${id}`,
      method: 'post',
    });
  },
  //  超级管理员》动火配电箱管理》动火配电箱管理分页列表
  getList: (content) => {
    return axios({
      url: `/power-box-node/power-node-paged-list`,
      method: 'post',
      data: content,
    });
  },
  // 超级管理员》动火配电箱管理》动火配电箱更新项目绑定状态 
  getEdit: (content) => {
    return axios({
      url: `/power-box-node/power-node-edit/${content.projectid}`,
      method: 'post',
      data: content,
    });
  },
  // 超级管理员》动火配电箱管理》配电箱详情信息 
  getDetail: (qrcode) => {
    return axios({
      url: `/power-box-node/power-node-box-detail-info/${qrcode}`,
      method: 'get',
    });
  },
  //  超级管理员》定制化配置》分页列表
  getCustomizedList: (content) => {
    return axios({
      url: `/specific-menu/paged-list`,
      method: 'post',
      data: content,
    });
  },
  //  超级管理员》定制化配置》保存配置(新增)
  addCustomized: (content) => {
    return axios({
      url: `/specific-menu/specific-menu`,
      method: 'post',
      data: content,
    });
  },
  //  超级管理员》定制化配置》保存配置(编辑)
  saveCustomized: (content) => {
    return axios({
      url: `/specific-menu/save-specific-menu`,
      method: 'post',
      data: content,
    });
  },
  //  超级管理员》定制化配置》删除配置
  delCustomized: (id) => {
    return axios({
      url: `/specific-menu/specific-menu-delete/${id}`,
      method: 'post',
    });
  },
  // 超级管理员》定制化配置》根据ID获取定制化数据 
  getCustomizedDetail: (id) => {
    return axios({
      url: `/specific-menu/model/${id}`,
      method: 'get',
    });
  },
};

export let Api_Company = {
  // 公司信息
  info: (companyid) => {
    return axios({
      url: `/company/company-info/${companyid}`,
      method: 'get',
    });
  },
  // 添加人员
  addUser: (data) => {
    return axios({
      url: `/company/user-add`,
      method: 'post',
      data: data,
    });
  },
  editUser: (data) => {
    return axios({
      url: `/company/user-edit`,
      method: 'post',
      data: data,
    });
  },
  // 人员列表
  getUserList: (data) => {
    return axios({
      url: `/company/user-list`,
      method: 'post',
      data: data,
    });
  },
  delUser: (data) => {
    return axios({
      url: `/company/user-delete/${data}`,
      method: 'post',
    });
  },
  // 编辑公司信息
  list: (content) => {
    return axios({
      url: `/company/company-list`,
      method: 'post',
      data: content,
    });
  },

  // 添加公司信息
  detail: (companyid) => {
    return axios({
      url: `/company/company-model/${companyid}`,
      method: 'get',
    });
  },

  // 添加公司信息
  add: (content) => {
    return axios({
      url: `/company/company-add`,
      method: 'post',
      data: content,
    });
  },
  // 编辑公司信息
  edit: (content) => {
    return axios({
      url: `/company/company-info-save`,
      method: 'post',
      data: content,
    });
  },
  // 分公司管理下的 编辑公司信息
  editUpdate: (content) => {
    return axios({
      url: `/company/company-edit`,
      method: 'post',
      data: content,
    });
  },
  // 删除公司
  del: (id) => {
    return axios({
      url: `/company/company-delete/` + id,
      method: 'post',
    });
  },
  projectList: (content) => {
    return axios({
      url: `/company/project-list`,
      method: 'post',
      data: content,
    });
  },
  // 集团》分公司管理》获取选中菜单列表
  getMenuSelect: (companyid) => {
    return axios({
      url: `/company/project-menus/${companyid}`,
      method: 'get',
    });
  },
  // 集团》分公司管理》保存项目权限菜单
  setMenuModules: (content) => {
    return axios({
      url: `/company/company-menu-add`,
      method: 'post',
      data: content,
    });
  },
  //分公司管理》授权模块
  getCompanyMenus: (content) => {
    return axios({
      url: `/company/company-tree-menus`,
      method: 'post',
      data: content,
    });
  },
  //分公司管理》工程管理
  getProjectTrees: (content) => {
    return axios({
      url: `/project-manage/company-template-tree-menus`,
      method: 'post',
      data: content,
    });
  },
  //分公司详情
  projectDetail: (id) => {
    return axios({
      url: `/company/project-model/${id}`,
      method: 'get',
    });
  },
  // 添加项目
  addProject: (content) => {
    return axios({
      url: `/company/project-add`,
      method: 'post',
      data: content,
    });
  },
  // 编辑项目
  editProject: (content) => {
    return axios({
      url: `/company/project-edit`,
      method: 'post',
      data: content,
    });
  },
  //删除项目
  delProject: (id) => {
    return axios({
      url: `/company/project-delete/${id}`,
      method: 'post',
    });
  },

};

export let Api_Base = {
  // 项目施工阶段
  getProjectStages: () => {
    return axios({
      url: `/public-common/project-stage-list`,
      method: 'get',
    });
  },
  // 项目施工阶段(新)
  getProjectStagesNew: () => {
    return axios({
      url: `/public-common/project-stage-new-list`,
      method: 'get',
    });
  },
  // 适用规范列表
  getUseTypeList: () => {
    return axios({
      url: `/public-common/project-use-type-list`,
      method: 'get',
    });
  },
  // 结构类型列表
  getStructList: () => {
    return axios({
      url: `/public-common/project-struct-list`,
      method: 'get',
    });
  },
  // 付款类型列表
  getMoneyTypeList: () => {
    return axios({
      url: `/public-common/receive-money-list`,
      method: 'get',
    });
  },
  // 付款类型列表
  upLoadFileFunction: (type, data) => {
    return axios({
      url: `/public-common/upload-file/` + type,
      method: 'post',
      data: data,
    });
  },
  // 上传文件
  upLoadFile: '/public-common/upload-file',
  // // 付款类型列表
  // getMoneyTypeList: () => {
  //   return axios({
  //     url: `/public-common/receive-money-list`,
  //     method: 'get',
  //   })
  // },
  // 获取项目状态列表
  getProjectStatus: () => {
    return axios({
      url: `/public-common/project-status-list`,
      method: 'get',
    });
  },
  //工程管理》授权模块
  getProjectMenus: (content) => {
    return axios({
      url: `/project-manage/project-template-tree-menus`,
      method: 'post',
      data: content,
    });
  },
  //工程管理》新增
  getProvinceMenus: (content) => {
    return axios({
      url: `/system-province-template/template-list-by-province`,
      method: 'post',
      data: content,
    });
  },
};

export let Api_System = {
  // 平台类型
  getPlatList: () => {
    return axios({
      url: `/system-config/plat-form-select`,
      method: 'get',
    });
  },
  // 项目类型
  getProjectType: () => {
    return axios({
      url: `/system-config/project-type-select`,
      method: 'post',
    });
  },
  // 单位类型
  getUnitType: () => {
    return axios({
      url: `/system-config/unit-type-select`,
      method: 'get',
    });
  },

  // 功能类型
  getOperateList: () => {
    return axios({
      url: `/system-config/operate-select`,
      method: 'get',
    });
  },
};
// 项目部账号-参建单位管理
export let Api_unit = {
  // 参建单位列表
  getUnitList: (data) => {
    return axios({
      url: `/project-manage/unit-list`,
      method: 'post',
      data: data,
    });
  },
  addUnit: (data) => {
    return axios({
      url: `/project-manage/unit-add`,
      method: 'post',
      data: data,
    });
  },
  editUnit: (data) => {
    return axios({
      url: `/project-manage/unit-edit`,
      method: 'post',
      data: data,
    });
  },
  delUnit: (data) => {
    return axios({
      url: `/project-manage/unit-delete/${data}`,
      method: 'post',
    });
  },
  detail: (id) => {
    return axios({
      url: `/project-manage/unit-select/${id}`,
      method: 'post',
    });
  },
  setUnitModules: (data) => {
    return axios({
      url: `/project-manage/save-unit-menu`,
      method: 'post',
      data: data,
    });
  },
  getUnitSelect: (unitid) => {
    return axios({
      url: `/project-manage/unit-menu-by-unit-id/${unitid}`,
      method: 'get',
    });
  },
  getUnitSubSelect: (unitid) => {
    return axios({
      url: `/project-manage/unit-sub-menu-by-unit-id/${unitid}`,
      method: 'get',
    });
  },
  //参建单位列表
  getContractorList: (data) => {
    return axios({
      url: `/project-manage/contractor-list`,
      method: 'post',
      data: data,
    });
  },
  addContractor: (data) => {
    return axios({
      url: `/project-manage/add-contractor`,
      method: 'post',
      data: data,
    });
  },
  editContractor: (data) => {
    return axios({
      url: `/project-manage/edit-contractor`,
      method: 'post',
      data: data,
    });
  },
  delContractor: (id) => {
    return axios({
      url: `/project-manage/delete-contractor/${id}`,
      method: 'post',
    });
  },
  //根据项目id查 参建单位列表
  getContractorListById: (projectId) => {
    return axios({
      url: `/project-manage/contractor-list-by-project-id/${projectId}`,
      method: 'get',
    });
  },

};

// 项目部账号-部门管理
export let Api_depart = {
  // 部门列表
  getDepartList: (data) => {
    return axios({
      url: `/project-manage/department-list`,
      method: 'post',
      data: data,
    });
  },
  addDepart: (data) => {
    return axios({
      url: `/project-manage/department-add`,
      method: 'post',
      data: data,
    });
  },
  editDepart: (data) => {
    return axios({
      url: `/project-manage/department-edit`,
      method: 'post',
      data: data,
    });
  },

  detail: (id) => {
    return axios({
      url: `/project-manage/department-select/${id}`,
      method: 'post',
    });
  },
  delDepart: (data) => {
    return axios({
      url: `/project-manage/department-delete/${data}`,
      method: 'post',
    });
  },
};

// 项目部账号-角色管理
export let Api_role = {
  // 角色列表
  getRoleList: (data) => {
    return axios({
      url: `/project-manage/role-list`,
      method: 'post',
      data: data,
    });
  },
  addRole: (data) => {
    return axios({
      url: `/project-manage/role-add`,
      method: 'post',
      data: data,
    });
  },
  editRole: (data) => {
    return axios({
      url: `/project-manage/role-edit`,
      method: 'post',
      data: data,
    });
  },
  delRole: (data) => {
    return axios({
      url: `/project-manage/role-delete/${data}`,
      method: 'post',
    });
  },
  detail: (id) => {
    return axios({
      url: `/project-manage/role-select/${id}`,
      method: 'post',
    });
  },
  // 获取选中菜单列表
  getProjectSelect: (roleid) => {
    return axios({
      url: `/company/menu-by-role-id/${roleid}`,
      method: 'get',
    });
  },
  // 获取选中菜单列表
  getProjectSubSelect: (roleid) => {
    return axios({
      url: `/company/sub-menu-by-role-id/${roleid}`,
      method: 'get',
    });
  },
  // 添加权限
  setProjectModules: (data) => {
    return axios({
      url: `/project-manage/role-menu-add`,
      method: 'post',
      data: data,
    });
  },
};
// 项目部账号-人员
export let Api_user = {
  // 人员列表
  getUserList: (data) => {
    return axios({
      url: `/project-manage/user-list`,
      method: 'post',
      data: data,
    });
  },
  addUser: (data) => {
    return axios({
      url: `/project-manage/user-add`,
      method: 'post',
      data: data,
    });
  },
  editUser: (data) => {
    return axios({
      url: `/project-manage/user-edit`,
      method: 'post',
      data: data,
    });
  },
  delUser: (data) => {
    return axios({
      url: `/project-manage/user-delete/${data}`,
      method: 'post',
    });
  },
  detail: (id) => {
    return axios({
      url: `/project-manage/user-select/${id}`,
      method: 'post',
    });
  },
  //工程资料权限列表
  getEngineerList: (userid) => {
    return axios({
      url: `/public-common/engineering-list`,
      method: 'get',
    });
  },
};
// 公司权限、项目权限配置AI盒子、眼镜、模型管理
export let Api_setting = {
  // 保存挂接信息(智能眼镜、AI盒子)
  saveConfig: (data) => {
    return axios({
      url: `/other-config/save-other-config`,
      method: 'post',
      data: data,
    });
  },
  // 获取列表
  getConfigList: (data) => {
    return axios({
      url: `/other-config/list`,
      method: 'post',
      data: data,
    });
  },
  getVideoList: (data) => {
    return axios({
      url: `/api/video-module/list`,
      method: 'post',
      data: data,
    });
  },
  // 根据id获取详情
  getConfigInfo: (data) => {
    return axios({
      url: `/other-config/model/${data.id}`,
      method: 'get',
    });
  },
  // 删除
  delConfig: (data) => {
    return axios({
      url: `/other-config/other-config-delete/${data.id}`,
      method: 'post',
    });
  },
  // 保存Pkpm挂接信息
  savePkAccount: (data) => {
    return axios({
      url: `/other-config/save-pk-pm-account`,
      method: 'post',
      data: data,
    });
  },
  // 获取Pkpm帐号信息
  getPkAccount: () => {
    return axios({
      url: `/other-config/pkpm-account`,
      method: 'get'
    });
  },
  // 删除
  delPkConfig: (data) => {
    return axios({
      url: `/other-config/account-delete/${data.id}`,
      method: 'post',
    });
  },
}
